import { useTranslation } from "react-i18next";
import ServiceCard from "./ServiceCard";

function ServicesSection() {
    const { t } = useTranslation("global");
    
    const services = [
      { 
        title: t("home.third-section-6"),
        description: t("home.third-section-6-desc", 
          "Obtenez une évaluation sur mesure.")
      },
      { 
        title: t("home.third-section-3"),
        description: t("home.third-section-3-desc", 
          "Visualisez vos progrès avec des tableaux de bord intuitifs et des rapports détaillés") 
      },
      { 
        title: t("home.third-section-5"),
        description: t("home.third-section-5-desc", 
          "Recevez des conseils d'experts pour améliorer vos processus") 
      },
      { 
        title: t("home.third-section-1"),
        description: t("home.third-section-1-desc", 
          "Gérez et suivez vos plans d'action pour une amélioration continue") 
      },
      { 
        title: t("home.third-section-2"),
        description: t("home.third-section-2-desc", 
          "Bénéficiez d'un accompagnement personnalisé tout au long de votre parcours") 
      },
      { 
        title: t("home.third-section-4"),
        description: t("home.third-section-4-desc", 
          "Évaluez et gérez la conformité de vos fournisseurs en toute simplicité") 
      },
    ];
    
    return (
      <section id="services" className="py-16">
        <div className="container mx-auto px-4">
          <div className="bg-blue-800 rounded-xl p-8 md:p-12">
            <div className="text-center mb-8">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-white">
                {t("home.third-section-title")}
              </h2>
              <p className="text-white text-xl mt-4 max-w-3xl mx-auto">
                {t("home.third-section-paragraphe")}
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {services.map((service, index) => (
                <ServiceCard
                  key={index}
                  title={service.title}
                  description={service.description}
                  index={index}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }
  
  export default ServicesSection;